import { SharingDraft } from '@/types';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchUserDrafts = (userId: string) =>
  requestToJSON<SharingDraft[]>(getRequest(`/api/users/${userId}/drafts`));
